import React, { SyntheticEvent } from 'react';
import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router';
import { Button } from '../components';
import { FormInput } from '../components/forms/FormInput';
import { handleValidateEmail } from '../data/handleValidateEmail';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../contexts/AuthContext';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  const { currentUser } = useAuth();
  const [email, setEmail] = React.useState('');
  const [working, setWorking] = React.useState(false);
  const navigate = useNavigate();

  // A SIGNED-IN USER GOES TO /login, WHOSE NAVIGATION EFFECT ALREADY ROUTES EVERY SIGNED-IN CASE: AN
  // AGENT-ONLY USER TO /sessions, A MISSING PATIENT DOC TO THE createPatient SELF-HEAL, A STORED
  // requestedURL, AND EVERYONE ELSE TO /{uid}. ABOUT 20 PAGES "NAVIGATE HOME" TO '/' AND LANDED ON THIS
  // EMAIL FORM INSTEAD (CU-17tm466qbce). AuthContext RENDERS CHILDREN ONLY ONCE AUTH HAS RESOLVED, SO
  // currentUser IS FINAL HERE.
  if (currentUser) {
    return <Navigate to="/login" />;
  }

  const handleSubmitClick = async (e: SyntheticEvent) => {
    e.preventDefault();
    window.localStorage.setItem('initialEmail', email);
    setWorking(true);

    const validatedEndPoint = await handleValidateEmail({ email: email });
    const endPoint = validatedEndPoint?.data?.endpoint ?? 'login';  // ✅ Direct access with fallback

    setWorking(false);
    navigate({
      to: `/${endPoint}`,
      from: '/',
    });
  };

  return (
    <>
      <Helmet>
        {/* Prevent email from leaking to external sites via referrer header when navigating in from magic link*/}
        <meta name="referrer" content="no-referrer-when-downgrade"></meta>{' '}
      </Helmet>
      <div className="flex h-screen flex-col items-center justify-center bg-stone-100">
        <img
          src="https://storage.googleapis.com/mideoid-console-public/logos/MIDEOhealth.png"
          alt="mideo_logo"
          className="h-36"
        />
        {/* <Button id="nav-login" type="button" textContent="Go to Login Page" onClick={handleSubmitClick} /> */}
        {/* <Button id="nav-enroll" type="button" textContent="Go to Employer Enrollment" onClick={handleEnrollClick} /> */}
        <form className="mt-4 flex flex-col items-center">
          <FormInput
            id="username"
            handleBlur={() => {}}
            label="Enter Email Address to Continue*"
            name="username"
            value={email}
            handleChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
          <p className="w-1/2 text-center text-xl italic">
            *Patients redeeming a benefit from their workplace or organization should enter their company email address.
          </p>
          <Button
            id="submit"
            type="submit"
            onClick={(e) => handleSubmitClick(e)}
            textContent="Submit"
            working={working}
            disabled={working}
            workingText="Checking email..."
          />
        </form>
      </div>
    </>
  );
}
